const STORAGE_KEY = "apily-chunk-reload-at";
const RELOAD_WINDOW_MS = 10000;

// sessionStorage can throw in private mode. One reload per page load then, so a missing chunk cannot loop.
let storageFallbackUsed = false;

export const chunkLoadRecovery = {
  reload() {
    window.location.reload();
  },
};

export function isChunkLoadError(error) {
  if (!error) return false;
  const name = typeof error === "object" && error.name ? String(error.name) : "";
  const message = typeof error === "object" && "message" in error ? String(error.message) : String(error);
  if (name === "ChunkLoadError") return true;
  return /Loading chunk .+ failed/i.test(message)
    || /Failed to fetch dynamically imported module/i.test(message)
    || /error loading dynamically imported module/i.test(message)
    || /Importing a module script failed/i.test(message);
}

// A deploy replaces hashed chunks. A tab that is already open still asks for the old names and gets 404.
// Reload once so the new index.html and its chunks load together; ignore a repeat inside the window.
export function reloadOnceForChunkError() {
  const now = Date.now();
  let recentlyReloaded = false;
  try {
    const previous = Number(sessionStorage.getItem(STORAGE_KEY));
    recentlyReloaded = Number.isFinite(previous) && now - previous < RELOAD_WINDOW_MS;
    if (!recentlyReloaded) sessionStorage.setItem(STORAGE_KEY, String(now));
  } catch {
    if (storageFallbackUsed) return false;
    storageFallbackUsed = true;
  }
  if (recentlyReloaded) return false;
  chunkLoadRecovery.reload();
  return true;
}

function onUnhandledRejection(event) {
  if (!isChunkLoadError(event.reason)) return;
  event.preventDefault();
  reloadOnceForChunkError();
}

export function installChunkLoadRecovery() {
  if (typeof window === "undefined" || window.__apilyChunkLoadRecovery) return;
  window.__apilyChunkLoadRecovery = true;
  window.addEventListener("unhandledrejection", onUnhandledRejection);
}
